<template>
  <div class="act-countdown" :class="[cssType, locale]" v-if="state.label">
    <div class="countdown-label">{{ state.label }}</div>
    <div class="countdown-value" v-if="!state.finished">
      <span class="box day" v-if="state.parts.hasDay">{{ state.parts.day }} {{ $t('sf.day') }}</span>
      <span class="box">{{ state.parts.hour }}</span>
      <span class="sep">:</span>
      <span class="box">{{ state.parts.minute }}</span>
      <span class="sep">:</span>
      <span class="box">{{ state.parts.second }}</span>
    </div>
  </div>
</template>

<script setup>
import { onUnmounted, reactive, watch, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import { formatCountdownParts } from '../../utils/time'

const props = defineProps({
  // 服务器毫秒时间戳（活动配置下发），用于校准本地时钟
  serverMs: {
    type: Number,
    default: 0,
  },
  startMs: {
    type: Number,
    default: 0,
  },
  endMs: {
    type: Number,
    default: 0,
  },
})

const { t, locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'

const state = reactive({
  label: '',
  finished: false,
  parts: formatCountdownParts(0),
})

let timer = null
let serverBaseMs = 0
let localBaseMs = 0

const stopTimer = () => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}

const computeState = () => {
  if (!serverBaseMs) {
    state.label = ''
    return
  }
  const now = serverBaseMs + (Date.now() - localBaseMs)

  if (props.startMs && now < props.startMs) {
    state.finished = false
    state.label = t('novShopping.countdown.start')
    state.parts = formatCountdownParts(props.startMs - now)
    return
  }
  if (!props.endMs || now >= props.endMs) {
    state.finished = true
    state.label = t('novShopping.status.ended')
    state.parts = formatCountdownParts(0)
    stopTimer()
    return
  }
  state.finished = false
  state.label = t('novShopping.countdown.end')
  state.parts = formatCountdownParts(props.endMs - now)
}

const startTimer = () => {
  stopTimer()
  serverBaseMs = Number(props.serverMs) || 0
  localBaseMs = Date.now()
  computeState()
  if (state.finished) return
  timer = setInterval(computeState, 1000)
}

watch(
  () => [props.serverMs, props.startMs, props.endMs],
  startTimer,
  { immediate: true }
)

watch(locale, computeState)

onUnmounted(stopTimer)
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
